import { People } from 'iconsax-react';

interface ResponseBagdeProps {
  count: number;
}

export const ResponseBagde = ({ count }: ResponseBagdeProps) => {
  return (
    <div className='flex items-center gap-1.5 w-fit rounded-xl px-2 h-8 bg-secondary-100 border border-secondary-200'>
      <span className='text-sm font-medium text-secondary-1000'>{count}</span>
      <People
        size='18'
        variant='Bold'
        className='text-secondary-1000'
      />
    </div>
  );
};
